import React, { useState, useEffect } from "react";
import Header from "../../components/header/index.js";
import LeftMenu from "../../components/left-menu/index.js";
import { useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
import Grid from '@mui/material/Grid';
import {readEmpty} from "../SalesMeeting/apiEmpty.js";
import "./style.css";
import { DatePicker } from '@mui/x-date-pickers';
import { Select, MenuItem } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import axios from "axios";
import Button from '@mui/material/Button';
import { Typography, Dialog, LinearProgress, DialogContent, Box, Card } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Switch} from "@mui/material";

export default function LegalProcess() {
    const [selectedPerson, setSelectedPerson] = useState('Adnan');
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [data, setData] = useState([]);
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB').format(date); // Format date as DD/MM/YYYY
      };
      const fetchData = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/cekpickontrak`, {
            params: {
                nomorKontrak
            }
        })
        .then(response => {
            console.log(response.data);
            // Check if response.data is empty (null, undefined, or an empty object/array)
            if (!response.data || Object.keys(response.data).length === 0) {
                setData(null);
            } else {
                setData(response.data);
            }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            setData(null);
        });
    };
    
    const [nomorKontrak, setNomorkontrak] = useState()

    useEffect(() => {
        fetchData();
    }, [nomorKontrak]);

    const handlePersonChange = (event) => {
        setSelectedPerson(event.target.value);
      };

    const handleDateChangeStart = (newDate) => {
        setSelectedStartDate(newDate);
    };
    const handleDateChangeEnd = (newDate) => {
        setSelectedEndDate(newDate);
    };

    const checkStatus = (aa) => {
        if (!aa || Object.keys(aa).length === 0) {
          return "Masukkan Nomor Kontrak yang Valid";
        }
      
        if (aa?.statusExtend === "Yes") {
          return "Sudah Extent";
        } else if (aa?.TanggalBerakhir && new Date(aa.TanggalBerakhir) < new Date()) {
          return "Sudah Expired, Silahkan Handle";
        } else if (!aa?.salesperson || !["Felly", "Adnan", "Dinda"].includes(aa.salesperson)) {
          return "Tidak ada Sales yang Handle, info Reinner";
        } else if (aa?.nextextendReminder === "Drop") {
          return `Drop by ${aa.salesperson}`;
        } else if (aa?.nextextendReminder) {
          return `${aa.salesperson} request Remind ${formatDate(aa.nextextendReminder)}`;
        } else if (aa?.nowRemind === "Yes") {
          return `Info ${aa.salesperson} FU`;
        }
        return 'error';
      };
    
      
      return (
        <Grid container>   
            <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                <LeftMenu/>
            </Grid>
            <Grid xl={11.5} lg={11.3} md={10.4} sm={8.8} sx={{py:10, px:10}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container>
                    <Grid xs={3}>
                        Nomor Kontrak:
                        <TextField
                        value={nomorKontrak}
                        onChange={(e) => setNomorkontrak(e.target.value)}
                        fullWidth
                        InputLabelProps={{
                        shrink: true,
                        }}
                    />
                    </Grid>
                </Grid>
                </LocalizationProvider>
                <Grid container sx={{py:2}}>
                    <Grid xs={9} sx={{px:1}}>
                    <Card sx={{p:2}}>
                        <Typography sx={{ color: 'text.secondary' }}><b>{data ? checkStatus(data.kontrakPICChecked) : ""}</b></Typography>
                    </Card>
                    </Grid>

                    
                </Grid>

               
            </Grid>
        </Grid>
    );
}
